
import { Signal } from "signals";
import ReelComponent from "slotworks/components/matrix/reel/reel-component";
import Layers from "slotworks/graphics/layers/layers";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";
import Contract from "slotworks/utils/contracts/contract";
abstract class AbstractReelTransition {

    public onReelLand: Signal = new Signal();
    public onAnticipationStart: Signal = new Signal();
    public onAnticipationEnd: Signal = new Signal();

    public animationLayer: Layers;

    protected reels: ReelComponent[];

    protected matrixLayer: Layers;

    protected defaultReelset: string[][];

    public init(reels: ReelComponent[], stops: number[], reelset: string[][]) {
        this.reels = reels;

        this.matrixLayer = this.reels[0].getMatrixLayer();
        this.animationLayer = this.reels[0].getAnimationLayer();
        this.defaultReelset = [];
        reelset.forEach((reel: string[]) => {
            this.defaultReelset.push([... reel]);
        });
    }

    public start(reelset?: string[][], jumpStart: boolean = false, quickSpin: boolean = false): Contract<void> {
        return new Contract<void>((resolve) => {
            resolve(null);
        });
    }

    public stop(spinRecord: SpinRecord, quickSpin: boolean = false): Contract<void> {
        return new Contract<void>((resolve) => {
            resolve(null);
        });
    }

    public skip(spinRecord: SpinRecord): Contract<void> {
        return new Contract<void>((resolve) => {
            resolve(null);
        });
    }

    public canSkip() {
        return true;
    }

    public hold(reelIndexes?: number[]) {
        // Hold specified reels
    }

    public jump(stops: number[], reelset: string[][]) {
        // jump to stops
    }

    public update() {
        // Update tick for transition
    }

    public postUpdate() {
        // Update tick for transition, after matrix has redrawn
    }

    public setCustomReelset(reelset: string[][]) {
        // Set a custom reelset for future use
    }

    public resetReelsetToDefault() {
        // Reset the reelset to the default value
    }
}

export default AbstractReelTransition;
